module.exports = __webpack_public_path__ + "logo.svg?c9c88ce8c8d96cb8212e2ecd43e2ffc8";


//////////////////
// WEBPACK FOOTER
// ./public/img/logo.svg
// module id = 102
// module chunks = 10